import { FunctionComponent, useState } from 'react'
import {
  Typography,
  Box,
  ListItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { navItems } from './nav-items'
import { useTranslation } from 'react-i18next'

const StyledBox = styled(Box)({
  display: 'flex',
  height: '64px',
  alignItems: 'center',
  cursor: 'pointer',
  position: 'relative',
  transition: '0.3s linear',
  '&:hover svg': {
    transform: 'rotateX(180deg)',
    transition: '0.3s linear',
  },
  '&:hover div': {
    visibility: 'visible',
    opacity: '1',
    transform: 'translateY(0)',
  },
})

const StyledTitle = styled(Typography)({
  fontWeight: '300',
  fontSize: '14px',
  lineHeight: '20px',
  '&:hover': {
    textDecoration: 'underline',
    textUnderlinePosition: 'under',
  },
})

const StyledDropdown = styled(Box)({
  transition: 'visibility .3s linear, transform .3s linear, opacity .3s linear',
  transform: 'translateY(20px)',
  transformOrigin: 'bottom',
  visibility: 'hidden',
  opacity: '0',
  position: 'absolute',
  zIndex: '150',
  padding: '36px',
  left: '0',
  top: '100%',
  width: '270px',
  background: 'rgb(3, 34, 76)',
  color: '#fff',
  boxShadow: '0 24px 24px #387d711a, 0 40px 48px #387d711a',
  borderRadius: '0 0 4px 4px',
})

const StyledLink = styled(ListItem)({
  fontWeight: '300',
  fontSize: '14px',
  lineHeight: '20px',
  '&:not(:last-child)': {
    marginBottom: '10px',
  },
  '&:hover': {
    textDecoration: 'underline',
    textUnderlinePosition: 'under',
  },
})

export const Navigation: FunctionComponent = () => {
  const navigate = useNavigate()
  const [isNonResidentModalOpen, setNonResidentModalOpen] = useState(false)
  const handleNonResidentClick = () => setNonResidentModalOpen(true)
  const { t } = useTranslation()

  return (
    <>
      {navItems.map((nav) => {
        const hasChildren = !!nav.subItems?.length

        return (
          <StyledBox key={nav.id}>
            {!hasChildren ? (
              <StyledLink key={nav.title} onClick={() => navigate(nav.path ?? '')}>
                {t(nav.id)}
              </StyledLink>
            ) : (
              <Typography>{t(nav.id)}</Typography>
            )}
            {hasChildren && (
              <>
                <ExpandMore
                  sx={{
                    marginLeft: '5px',
                    transition: '0.3s linear',
                    fontSize: '18px',
                  }}
                />
                <StyledDropdown>
                  {nav.subItems?.map((subNav) => (
                    <StyledLink
                      key={subNav.title}
                      onClick={() => navigate(subNav.path)}
                    >
                      {t(subNav.id)}
                    </StyledLink>
                  ))}
                </StyledDropdown>
              </>
            )}
          </StyledBox>
        )
      })}
      <StyledBox onClick={handleNonResidentClick}>
        <StyledTitle>Non-resident?</StyledTitle>
      </StyledBox>

      <Dialog open={isNonResidentModalOpen}>
        <DialogTitle>Info for non-residents</DialogTitle>

        <DialogContent>
          If you are a non-resident, please log in via Non-resident Login button. If
          you have no credentials to log in, contact us to get one.
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setNonResidentModalOpen(false)}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
